import { render, staticRenderFns } from "./associate.vue?vue&type=template&id=14fb0baa&scoped=true&lang=pug"
import script from "./associate.vue?vue&type=script&lang=js"
export * from "./associate.vue?vue&type=script&lang=js"
import style0 from "./associate.scss?vue&type=style&index=0&id=14fb0baa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fb0baa",
  null
  
)

export default component.exports